<ng-container *ngIf='!loading && company, else isLoading'>
  <form [formGroup]='companySettingsForm'>
    <div class='row'>
      <div class='column--8'>
        <h3>Settings Flags</h3>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='enforceSSO'><span class='no-bold text--sm'>Force the company to use SSO?</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm' *ngIf='canViewSsoConnections, else ssoConnectionReadOnly'>
      <div class='column--8' [matTooltip]='ssoConnectionTooltipText' matTooltipPosition='above' data-test='sso-connection-picker'>
        <mat-form-field class='w-100'>
          <mat-label>SSO connection</mat-label>
          <mat-select formControlName='ssoConnectionUuid'>
            <mat-option [value]='null'>Not assigned (falls back to Google)</mat-option>
            <mat-option *ngFor='let connection of ssoConnections' [value]='connection.uuid'>{{ connection.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <ng-template #ssoConnectionReadOnly>
      <div class='row mt--sm'>
        <div class='column--8' data-test='sso-connection-readonly'>
          <p class='text--sm mb--none'><strong>SSO connection</strong></p>
          <p class='text--sm mb--none'>{{ assignedSsoConnectionLabel }}</p>
        </div>
      </div>
    </ng-template>

    <div class='row' *ngIf='showSsoUnassignedWarning'>
      <div class='column--8'>
        <app-alert-banners data-test='sso-unassigned-warning' [notification]='ssoUnassignedNotification'></app-alert-banners>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='isLD'><span class='no-bold text--sm'>Is this a London Drugs company? (different EEKO rates for LD)</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='isLDTrexity'><span class='no-bold text--sm'>Is this a London Drugs company? (different Trexity rates for LD)</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='taxExempt'><span class='no-bold text--sm'>Is the company tax exempt?</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='addBlindMarginAllowed'><span class='no-bold text--sm'>Can the company add blind markups?</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='showCustomerReceipt'><span class='no-bold text--sm'>Should we show customer receipts for this company?</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='isSigneLocal'><span class='no-bold text--sm'>Is this a Signé Local Company? (different Canada Post account)</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='hasNoShipments'><span class='no-bold text--sm'>This company has no shipments currently?</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='fraudWhitelist'><span class='no-bold text--sm'>This company is whitelisted from fraud detection?</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--sm'>
      <div class='column--8'>
        <mat-checkbox class="text--sm" color='primary' formControlName='isFraudulent'><span class='no-bold text--sm'>Is the company suspected for fraudulent activity?</span></mat-checkbox>
      </div>
    </div>

    <div class='row mt--md'>
      <div class='column--12'>
        <button mat-flat-button color='primary' type='submit' [disabled]="!canEdit || companySettingsForm.invalid || loading" (click)='submit()'>Save</button>
      </div>
    </div>

  </form>
</ng-container>
<ng-template #isLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
